import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {ChangePasswordDialogComponent} from '@app/app/profile/change-password-dialog.component';
import {MatDialog} from '@angular/material';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';

@Component({
  moduleId: module.id,
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.css']
})
export class ProfileComponent implements OnInit {
  public profileForm: FormGroup;

  public profile = {
    type: '',
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    company_name: '',
  };

  public success = '';
  public error = '';
  public editState = false;
  public isClient = false;
  public isLoading = false;

  constructor(public dialog: MatDialog, private http: HttpClient,
              private route: ActivatedRoute, private auth: AuthenticationService, private urlHelper: UrlHelper) {
    //
  }

  ngOnInit() {
    if (this.auth.userRole() === 'client') {
      this.isClient = true;
    }

    this.http.get('/users/me').subscribe((res: any) => {
      this.initData(res);
    });

    if (this.isClient) {
      this.profileForm = new FormGroup({
        phone: new FormControl('', Validators.required),
      });
    } else {
      this.profileForm = new FormGroup({
        first_name: new FormControl('', Validators.required),
        last_name: new FormControl('', Validators.required),
        phone: new FormControl('', Validators.required),
      });
    }
  }

  initData(res) {
    this.profile.type = res.data.type;
    this.profile.id = res.data.id;
    this.profile.email = res.data.attributes.email;
    this.profile.first_name = res.data.attributes.first_name;
    this.profile.last_name = res.data.attributes.last_name;
    this.profile.phone = res.data.attributes.phone;
    this.profile.company_name = res.data.attributes.company_name;

    if (this.isClient) {
      this.profileForm.patchValue({
        phone: res.data.attributes.phone
      });
    } else {
      this.profileForm.patchValue({
        first_name: res.data.attributes.first_name,
        last_name: res.data.attributes.last_name,
        phone: res.data.attributes.phone
      });
    }
  }

  onSubmit({value, valid}) {
    if (valid) {
      let role = '';
      let type = '';

      switch (this.auth.userRole()) {
        case 'admin':
          role = 'admins';
          type = 'Admins';
          break;
        case 'manufacturer':
          role = 'manufacturers';
          type = 'Manufacturers';
          break;
        case 'client':
          role = 'clients';
          type = 'Clients';
          break;
        case 'employee':
          role = 'employees';
          type = 'Employees';
          break;
      }

      const body: any = {
        data: {
          type: type,
          id: this.auth.userId(),
          attributes: {
            phone: value.phone,
          }
        }
      };

      if (!this.isClient) {
        body.data.attributes.first_name = value.first_name;
        body.data.attributes.last_name = value.last_name;
      }

      this.isLoading = true;

      this.http.put(`${this.urlHelper.getPrefix()}/profile`, body).subscribe(
        (res) => {
          this.editState = false;
          this.isLoading = false;
          this.initData(res);
        }, (err) => {
          this.isLoading = false;
          this.error = 'Something go wrong. Please try later.';
        }, () => {
          this.isLoading = false;
        });
    }
  }

  onCloseCancel() {
    this.editState = false;
  }

  editProfile() {
    this.editState = true;
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res === 'The password was updated.') {
        this.success = res;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts